import Vue from 'vue';
// import VueMq from 'vue-mq';
import App from '@/App.vue';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
// import config from '@/config';
import bricodes from '@/bricodes';

// const isInProductionEnvironment = process.env.NODE_ENV === 'production';

const requireComponent = require.context('@/components', false, /[A-Z]\w+\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '');

  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.config.productionTip = false;

// Vue.use(VueMq, {
//   breakpoints: {
//     sm: 450,
//     md: 1280,
//     lg: Infinity,
//   },
// });

new Vue({
  i18n,
  router,
  store,
  bricodes,
  render: h => h(App),
}).$mount('#app');
